import './src/vaadin-upload.js';
export * from './src/vaadin-upload.js';
